// UserFollowingGridCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import UniversalContainer from '../component/UniversalContainer.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const UserFollowingGridCategoryRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalContainer filename="FollowingUserGridList" />
    </>
  );
};

export default UserFollowingGridCategoryRoute;
